module.exports = __webpack_public_path__ + "img/cupom.c161a9e6.svg";